import React, { FC, PropsWithChildren } from 'react';

import type { BettingContextProps } from '../types';

import { BettingContext } from 'app/contexts/betting';

// ---

type BettingProps = {
  context: BettingContextProps;
} & PropsWithChildren;

const BettingWrapper: FC<BettingProps> = ({ context, children }) => {
  return (
    <BettingContext.Provider value={context}>
      {children}
    </BettingContext.Provider>
  );
};

export default BettingWrapper;
